import "./PlayerInquiry.module.css";
import Header from "@/reusable_sections/Header";
import StartYourJourney from "./sections/StartYourJourney";
import ProspectProfileForm from "./sections/ProspectProfileForm";
import Footer from "@/reusable_sections/Footer";
export default function PlayerInquiryPage() {
  return <div>
      <Header />
      <StartYourJourney />
      <ProspectProfileForm />
      <Footer />
    </div>;
}